import React from 'react';
import TemplateFieldEditor from './TemplateFieldEditor';
import './TemplateBuilder.css';

// 템플릿 필드 빌더
// fields: TemplateField[]
// onChange: (fields) => void
const TemplateBuilder = ({ fields = [], onChange }) => {
  const addField = () => {
    onChange([
      ...fields,
      { key: '', label: '', type: 'string', required: false }
    ]);
  };

  const updateField = (index, updated) => {
    const next = [...fields];
    next[index] = updated;
    onChange(next);
  };

  const removeField = (index) => {
    onChange(fields.filter((_, i) => i !== index));
  };

  // 위로 이동
  const moveUp = (index) => {
    if (index === 0) return;
    const next = [...fields];
    [next[index - 1], next[index]] = [next[index], next[index - 1]];
    onChange(next);
  };

  // 아래로 이동
  const moveDown = (index) => {
    if (index === fields.length - 1) return;
    const next = [...fields];
    [next[index + 1], next[index]] = [next[index], next[index + 1]];
    onChange(next);
  };

  return (
    <div className="template-builder">
      {fields.length === 0 && (
        <p className="tb-empty">아직 필드가 없습니다. 아래 버튼으로 추가하세요.</p>
      )}

      {fields.map((field, index) => (
        <div key={index} className="tb-field-row">
          <div className="tb-order-btns">
            <button
              type="button"
              className="tb-order-btn"
              onClick={() => moveUp(index)}
              disabled={index === 0}
              aria-label="위로"
            >
              ▲
            </button>
            <span className="tb-order-num">{index + 1}</span>
            <button
              type="button"
              className="tb-order-btn"
              onClick={() => moveDown(index)}
              disabled={index === fields.length - 1}
              aria-label="아래로"
            >
              ▼
            </button>
          </div>
          <div className="tb-field-editor">
            <TemplateFieldEditor
              field={field}
              onChange={(updated) => updateField(index, updated)}
              onRemove={() => removeField(index)}
            />
          </div>
        </div>
      ))}

      <button
        type="button"
        className="tb-add-btn"
        onClick={addField}
      >
        + 필드 추가
      </button>
    </div>
  );
};

export default TemplateBuilder;
